import React, { useEffect, useRef } from 'react';

import { Color, colors } from 'theme';
import { useCSSVariables, useLoadSvgContent } from 'utils/hooks';

import styles from './Icon.module.scss';
import { IconName } from './IconName';
import { cssFilterForColor } from './cssFilterForColor';

type Props = {
  name: IconName;
  size: number;
  initialColorName: Color | 'todo-replace-me';
  keepColorOnLoad?: boolean;
  opacity?: number;
  'data-qa-id'?: string;
};

export function Icon({
  name,
  size,
  initialColorName: propInitialColorName,
  keepColorOnLoad,
  opacity,
  'data-qa-id': dataQaId,
}: Props) {
  const { svgSrc, svgContent, loadSvgContent } = useLoadSvgContent(
    `/static/images/icons/normalized/${name}.svg`
  );

  const initialColorName =
    // `todo-replace-me` was added to facilitate the transition
    // Remove it once we replace all occurrences
    propInitialColorName === 'todo-replace-me'
      ? 'aluminum'
      : propInitialColorName;

  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    if (img.complete) loadSvgContent();
    else img.addEventListener('load', loadSvgContent);
  }, [loadSvgContent]);

  const cssVariables = useCSSVariables({
    size: `${size}px`,
    color: keepColorOnLoad ? colors[initialColorName] : undefined,
    opacity,
  });

  if (!svgContent) {
    return (
      <div className={styles.icon} style={cssVariables} data-qa-id={dataQaId}>
        <img
          ref={imgRef}
          src={svgSrc}
          width={size}
          height={size}
          alt={`${name} icon`}
          style={{ filter: cssFilterForColor(initialColorName) }}
        />
      </div>
    );
  }

  return (
    <div
      className={styles.icon}
      style={cssVariables}
      data-qa-id={dataQaId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
}
